export const itemType = {
  CUSTOMURL: 'custom_url',
  BANNER: 'banner'
};